"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoNotFullOpen_greenIcon = createIcon({
  displayName: "CompRegoNotFullOpen_greenIcon",
  viewBox: "0 0 44.29 33",
  path: (
    <>
      <path
        d="M36.05,18.58v-4.12h-4.12v-4.12h4.12v-4.12h4.12v4.12h4.12v4.12h-4.12v4.12h-4.12ZM16.48,16.52c-2.27,0-4.2-.8-5.83-2.43-1.61-1.61-2.43-3.56-2.43-5.83s.8-4.2,2.43-5.83c1.63-1.63,3.56-2.43,5.83-2.43s4.2.8,5.83,2.43c1.63,1.63,2.43,3.56,2.43,5.83s-.8,4.2-2.43,5.83c-1.61,1.61-3.56,2.43-5.83,2.43ZM0,33v-5.77c0-1.17.31-2.25.91-3.21.6-.99,1.4-1.73,2.39-2.25,2.12-1.07,4.28-1.85,6.49-2.39,2.2-.54,4.43-.8,6.69-.8s4.49.27,6.69.8c2.2.54,4.37,1.34,6.49,2.39.99.52,1.79,1.26,2.39,2.25.6.99.91,2.06.91,3.21v5.77H0ZM16.48,12.4c1.13,0,2.1-.41,2.9-1.22s1.22-1.77,1.22-2.9-.41-2.1-1.22-2.9-1.77-1.22-2.9-1.22-2.1.41-2.9,1.22-1.22,1.77-1.22,2.9.41,2.1,1.22,2.9,1.77,1.22,2.9,1.22ZM4.12,28.88h24.72v-1.65c0-.37-.1-.72-.29-1.03-.19-.31-.43-.56-.74-.72-1.85-.93-3.73-1.63-5.62-2.08-1.9-.45-3.79-.7-5.73-.7s-3.83.23-5.73.7c-1.9.47-3.77,1.15-5.62,2.08-.31.16-.56.41-.74.72-.19.31-.29.66-.29,1.03v1.65h.04Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
    color: "green.500",
  },
});

export default CompRegoNotFullOpen_greenIcon;
